import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';

import { OasisAuthService } from '../../core/auth/oasis-auth.service';
import { PortalAvailabilityService } from '../../core/cycle/portal-availability';

@Component({
	selector: 'app-nav-bar',
	templateUrl: './nav-bar.component.html',
	imports: [CommonModule, RouterLink, RouterLinkActive],
})
export class NavBarComponent {
	private readonly auth = inject(OasisAuthService);
	private readonly portal = inject(PortalAvailabilityService);

	readonly isAuthenticated = this.auth.isAuthenticated;
	readonly email = this.auth.email;

	/**
	 * Whether to offer sign-in at all. Read once, when the nav bar is created: a
	 * visitor who sits on the page across the opening moment refreshes to see the
	 * button, which is a fair trade against polling for a once-a-year event.
	 */
	readonly portalOpen = this.portal.isOpen();

	/** Replaces the sign-in button until the portal opens. */
	readonly opensLabel = this.portal.opensLabel();

	logIn(): void {
		this.auth.login('/dashboard');
	}

	logOut(): void {
		this.auth.logout();
	}
}
